import { FRAMEWORK_INDUSTRY_TYPES } from '../../Constants/frameworkGatedMenu';

export const PILLAR_ALL = 'all';
export const SLUG_CYBER = 'cybersecuritydataprotection';
export const SLUG_AI = 'artificialintelligence';
export const SLUG_BRAND = 'intellectualproperty';

export const PILLAR_ALIASES = {
  ai: SLUG_AI,
  brand: SLUG_BRAND,
  cybersecuritydata: SLUG_CYBER,
};

export const industryToSlug = (industry) => {
  if (industry === 'Cyber Security' || industry === 'Data Protection') return SLUG_CYBER;
  return String(industry || '').replace(/[^a-zA-Z]/g, '').toLowerCase();
};

export const orderedPillars = () => {
  const seen = new Set();
  const list = [{ slug: PILLAR_ALL, label: 'All' }];
  FRAMEWORK_INDUSTRY_TYPES.forEach((industry) => {
    const slug = industryToSlug(industry);
    if (seen.has(slug)) return;
    seen.add(slug);
    list.push({ slug, label: pillarLabel(slug) });
  });
  return list;
};

/**
 * orderedPillars, limited to industries the org has a project for — the
 * same org industry set the sidebar menu gates on (loadOrgIndustryTypes).
 * `industryTypes` null (still loading) or empty leaves just "All", matching
 * the menu's fail-closed behaviour.
 */
export const pillarsForIndustries = (industryTypes) => orderedPillars().filter((p) => (
  p.slug === PILLAR_ALL
  || (!!industryTypes && industriesForSlug(p.slug).some((t) => industryTypes.has(t)))
));

export const pillarLabel = (slug) => {
  if (slug === PILLAR_ALL) return 'All';
  if (slug === SLUG_CYBER) return 'Cyber Security and Data Protection';
  if (slug === SLUG_BRAND) return 'IP and Brand Management';
  const match = FRAMEWORK_INDUSTRY_TYPES.find((t) => industryToSlug(t) === slug);
  return match || slug;
};

export const industriesForSlug = (slug) => {
  if (!slug || slug === PILLAR_ALL) return [];
  if (slug === SLUG_CYBER) return ['Cyber Security', 'Data Protection'];
  const match = FRAMEWORK_INDUSTRY_TYPES.find((t) => industryToSlug(t) === slug);
  return match ? [match] : [];
};

export const knownPillarSlugs = () => {
  const set = new Set([PILLAR_ALL]);
  FRAMEWORK_INDUSTRY_TYPES.forEach((t) => set.add(industryToSlug(t)));
  return set;
};

export const normalizePillar = (raw) => {
  const letters = String(raw || '').toLowerCase().replace(/[^a-z]/g, '');
  if (!letters) return PILLAR_ALL;
  const mapped = PILLAR_ALIASES[letters] || letters;
  if (!knownPillarSlugs().has(mapped)) return null;
  return mapped;
};

export const frameworkMatchesPillar = (industryTypes, pillar) => {
  if (!pillar || pillar === PILLAR_ALL) return true;
  const wanted = industriesForSlug(pillar);
  return (industryTypes || []).some((t) => wanted.includes(t));
};

export const policyMatchesPillar = (industryTypes, pillar) => {
  if (!industryTypes || industryTypes.length === 0) return !pillar || pillar === PILLAR_ALL;
  return frameworkMatchesPillar(industryTypes, pillar);
};

export const industryPillarOptions = () => (
  orderedPillars().filter((p) => p.slug !== PILLAR_ALL)
);

export const groupByIndustrySlug = (items = []) => {
  const buckets = new Map();
  items.forEach((item) => {
    const slug = item.industry_slug || '';
    if (!buckets.has(slug)) buckets.set(slug, []);
    buckets.get(slug).push(item);
  });
  const grouped = orderedPillars()
    .filter((p) => p.slug !== PILLAR_ALL && buckets.has(p.slug))
    .map((p) => ({ slug: p.slug, label: p.label, items: buckets.get(p.slug) }));
  if (buckets.has('')) {
    grouped.push({ slug: '', label: '', items: buckets.get('') });
  }
  return grouped;
};

export const isCustomTrustHost = () => {
  const h = window.location.hostname;
  if (!h || h === 'localhost' || h === '127.0.0.1') return false;
  return !h.includes('zavior');
};
